function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _rect, _path, _circle, _path2, _rect2, _path3, _path4, _rect3, _path5, _path6;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
import { Platform } from 'react-native';
import { createElement } from 'react';
var SvgPriceObjectionsAndNegotiation = function SvgPriceObjectionsAndNegotiation(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    x: 4,
    y: 4,
    fill: "#FEF3C7",
    rx: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#B45309",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M24 38h32l30 30-26 26-30-30z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 50,
    r: 4,
    fill: "#FEF3C7",
    stroke: "#B45309",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F59E0B",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M46 60h16m-8-8v16"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    x: 66,
    y: 26,
    fill: "#FFF",
    stroke: "#B45309",
    strokeWidth: 2.5,
    rx: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#B45309",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m76 46-2 6 8-6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B45309",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M72 34h18m-18 5h12"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 18,
    x: 26,
    y: 74,
    fill: "#FFF",
    stroke: "#F59E0B",
    strokeWidth: 2.5,
    rx: 8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#F59E0B",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m36 92-2 6 8-6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F59E0B",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M32 81h18m-18 5h12"
  })));
};
if (Platform.OS === 'web') {
  var ForwardRefNativeSvgIcon = /*#__PURE__*/React.forwardRef(SvgPriceObjectionsAndNegotiation);
  SvgPriceObjectionsAndNegotiation = function SvgPriceObjectionsAndNegotiation(props, ref) {
    return /*#__PURE__*/createElement(ForwardRefNativeSvgIcon, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }));
  };
}
var ForwardRef = /*#__PURE__*/forwardRef(SvgPriceObjectionsAndNegotiation);
export default ForwardRef;